import * as types from '../types.js';
import msgbox from '../../versa/msgbox.js';

const COMPANY_PARAMS_HELP_HTML = `
<div class="company-params-help-body">
<h4>Inventário — Permite vencido</h4>
<p>Quando marcado, o sistema pode considerar lotes com validade vencida nas operações de inventário desta empresa (caso contrário, tende a tratá-los como inelegíveis). Use com alinhamento à política fiscal e operacional do depositante.</p>
<h4>Inventário — Exige lote</h4>
<p>Exige identificação de lote nas rotinas de inventário: posições e contagens precisam estar vinculadas a um lote válido, reduzindo movimentação “sem lote”.</p>
<h4>Inventário — Por programa</h4>
<p>O inventário passa a respeitar o programa (ex.: alocação por programa de medicamentos): saldos e contagens são avaliados no contexto do programa do lote/produto, não apenas por SKU e posição.</p>
<h4>Inventário — Bloqueio por classe</h4>
<p>Aplica restrições ligadas à classe do produto (ex.: classes que exigem tratamento diferenciado no inventário ou na conferência). Complementa regras já existentes de produto/classe.</p>
<h4>Inventário — Tolerância conferência</h4>
<p>Valor inteiro de tolerância usado nas regras de conferência de inventário para esta empresa (margem aceitável antes de apontar divergência). Zero desativa tolerância adicional; ajuste conforme acordo operacional.</p>
<h4>Embalagens — Hierarquia de embalagens</h4>
<p>Ativa o modelo de embalagens em níveis (primária, secundária, terciária) cadastradas no produto. Sem isso, o SIAL permanece no comportamento legado (uma unidade de venda / embalagem simples).</p>
<h4>Embalagens — Unitarização</h4>
<p>Permite que o picking/operação utilize a <strong>embalagem primária</strong> (unidade fracionada) quando aplicável. Só faz sentido com hierarquia ativa e cadastro correto dos fatores. Clientes legados costumam deixar desmarcado.</p>
<h4>Embalagens — Picking otimizado</h4>
<p>O motor de separação tende a escolher combinações de embalagem que <strong>minimizem quebra</strong> de fardos/caixas (ex.: priorizar múltiplos da embalagem maior). Depende de cadastro de embalagens e, quando aplicável, capacidade terciária.</p>
<h4>Embalagens — Quebra terciária / secundária</h4>
<p><strong>Terciária:</strong> autoriza “abrir” o fardo/paletização para atender quantidades que não fecham múltiplo da terciária.<br>
<strong>Secundária:</strong> idem para o nível da caixa/fechamento secundário. Se desmarcado e o pedido exigir fração, o atendimento pode ficar bloqueado ou reduzido conforme a regra de picking.</p>
<h4>Embalagens — Valida GTIN (embalagem)</h4>
<p>Passa a validar o GTIN informado nas embalagens cadastradas (conferência com código de barras / evita divergência entre EAN do produto e o da embalagem).</p>
<h4>Embalagens — Rollback legado</h4>
<p>Força caminhos de processamento compatíveis com o fluxo anterior do sistema, ignorando extensões novas de embalagem/picking quando definido pela política de migração ou contingência.</p>
<h4>Pedidos de saída — Atendimento</h4>
<p><strong>Parcial (padrão):</strong> permite gerar saída com quantidades inferiores ao pendente do pedido, como hoje (várias remessas até concluir).</p>
<p><strong>Total:</strong> nesta empresa, a geração de saída só prossegue quando <strong>todas</strong> as linhas ainda pendentes forem atendidas <strong>integralmente</strong> na mesma operação; caso contrário, o sistema não cria a saída e informa o motivo.</p>
</div>`;

export default {

	html: `
		<style>
			#company #id					{ width: 20rem;		}
			#company #nick					{ width: 10rem; 	}
			#company #name					{ width: 25rem; 	}
			#company #cnpj					{ width: 10rem;		}
			#company #ie					{ width: 10rem;		}
			#company #ie_type				{ width: 10rem;		}
			#company #iest					{ width: 10rem;		}
			#company #phone					{ width: 10rem;		}
			#company #address_street		{ width: 30rem;		}
			#company #address_number		{ width: 5rem;		}
			#company #address_complement	{ width: 20rem;		}
			#company #address_district		{ width: 25rem;		}
			#company #address_state			{ width: 3.5rem;	}
			#company #address_city_id		{ width: 20rem;		}
			#company #address_zipcode		{ width: 6rem;		}
			#company #inventory_strategy	{ width: 6rem;		}
			#company #crt					{ width: 6rem;		}
			#company #pis					{ width: 4rem; text-align: right;	}
			#company #cofins				{ width: 4rem; text-align: right;	}
			#company #estimated_taxes		{ width: 4rem; text-align: right;	}
			#company #invoice_series		{ width: 4rem; text-align: right;	}
			#company #authorized_parties	{ width: 25rem; 	}
			#company #logo					{ width: 14rem; 	}
			#company #fiscal_modality		{ width: 10rem;		}
			#company #custody_warehouse_cnpj{ width: 12rem;		}
			#company #custody_emit_name			{ width: 28rem; }
			#company #custody_emit_ie			{ width: 12rem; }
			#company #custody_emit_phone		{ width: 10rem; }
			#company #custody_emit_crt			{ width: 6rem; }
			#company #custody_emit_address_street		{ width: 28rem; }
			#company #custody_emit_address_number		{ width: 5rem; }
			#company #custody_emit_address_complement	{ width: 18rem; }
			#company #custody_emit_address_district		{ width: 22rem; }
			#company #custody_emit_address_state			{ width: 3.5rem; }
			#company #custody_emit_address_city_id		{ width: 20rem; }
			#company #custody_emit_address_zipcode		{ width: 6rem; }
			#company #custody_emit_nfe_block { display: none; margin-top: 0.75rem; padding: 0.5rem 0; border-top: 1px solid #e5e7eb; }
			#company #custody_emit_nfe_block .custody-emit-title { font-size: 0.78rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em; color: #374151; margin: 0 0 0.5rem 0; }
			#company #inv_conference_tolerance { width: 5rem; text-align: right; }
			#company .company-params-fieldset { min-width: 0; }
			#company .param-block { margin-top: 0.85rem; }
			#company .param-block:first-of-type { margin-top: 0.35rem; }
			#company .param-block-title {
				margin: 0 0 0.5rem 0;
				font-size: 0.75rem;
				font-weight: 700;
				letter-spacing: 0.04em;
				color: #374151;
				text-transform: uppercase;
			}
			#company .param-grid {
				display: grid;
				grid-template-columns: repeat(2, minmax(0, 1fr));
				gap: 0.35rem 1rem;
				align-items: center;
			}
			@media (min-width: 520px) {
				#company .param-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
			}
			#company label.param-check {
				display: grid;
				grid-template-columns: 1.0625rem minmax(0, 1fr);
				column-gap: 0.5rem;
				align-items: center;
				min-height: 1.65rem;
				min-width: 0;
			}
			#company label.param-check input[type="checkbox"] {
				width: 1.0625rem;
				height: 1.0625rem;
				margin: 0;
			}
			#company label.param-check .param-check-text {
				line-height: 1.3;
				font-size: 0.875rem;
			}
			#company label.param-num {
				display: inline-flex;
				align-items: center;
				gap: 0.5rem;
				flex-wrap: wrap;
			}
			#company .param-num-label {
				font-size: 0.875rem;
				white-space: nowrap;
			}
			#company .param-grid .param-num.param-num--row {
				grid-column: 1 / -1;
				margin-bottom: 0.15rem;
			}
			#company .company-params-legend {
				display: flex;
				align-items: center;
				gap: 0.45rem;
				flex-wrap: wrap;
				padding: 0;
				margin: 0 0 0.15rem 0;
				font-size: inherit;
				font-weight: inherit;
			}
			#company .company-params-help {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 1.35rem;
				height: 1.35rem;
				padding: 0;
				border: 1px solid #9ca3af;
				border-radius: 999px;
				background: #f3f4f6;
				color: #374151;
				font-size: 0.85rem;
				font-weight: 700;
				line-height: 1;
				cursor: pointer;
			}
			#company .company-params-help:hover {
				background: #e5e7eb;
			}
			#company .company-params-help:focus {
				outline: 2px solid #2563eb;
				outline-offset: 2px;
			}
			#company .form-tabs { display: flex; flex-wrap: wrap; align-items: center; gap: 0.35rem 0.5rem; padding: 0 0 0 0.5rem; background: #f1f5f9; border-radius: 8px 8px 0 0; margin: 0 0 0.75rem 0; flex-shrink: 0; }
			#company .form-tab { padding: 0.65rem 1.1rem; cursor: pointer; font-weight: 600; font-size: 0.88rem; color: #64748b; background: transparent; border: none; border-radius: 6px; transition: all 0.15s ease; }
			#company .form-tab:hover { color: #334155; background: #e2e8f0; }
			#company .form-tab.active { color: #4f46e5; background: white; box-shadow: 0 -1px 3px rgba(0,0,0,0.06); }
			#company .form-tab-panels { min-height: 0; }
			#company .form-tab-panel { display: none; }
			#company .form-tab-panel.active { display: block; }
			#company .company-nfe-hint { font-size: 0.82rem; color: #4b5563; line-height: 1.45; margin: 0 0 0.75rem 0; max-width: 56rem; }
			#company .company-nfe-ph-block { margin-bottom: 0.85rem; max-width: 56rem; }
			#company .company-nfe-ph-label { display: block; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: #374151; margin-bottom: 0.35rem; }
			#company .company-nfe-ph-row { display: flex; flex-wrap: wrap; gap: 0.35rem; align-items: center; }
			#company button.company-inf-cpl-ph {
				font-size: 0.72rem; font-family: ui-monospace, monospace; padding: 0.2rem 0.45rem;
				border: 1px solid #cbd5e1; border-radius: 4px; background: #f8fafc; color: #334155; cursor: pointer;
			}
			#company button.company-inf-cpl-ph:hover { background: #e2e8f0; border-color: #94a3b8; }
			#company .company-nfe-textarea-label { display: block; width: 100%; max-width: 56rem; box-sizing: border-box; }
			#company #nfe_inf_cpl_entrada, #company #nfe_inf_cpl_saida { width: 100%; max-width: none; display: block; font-family: inherit; box-sizing: border-box; }
			#company .company-nfe-rt-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem 1rem; margin-top: 0.75rem; max-width: 48rem; }
			#company .company-nfe-rt-grid .io-span-2 { grid-column: span 2; }
			@media (max-width: 720px) { #company .company-nfe-rt-grid { grid-template-columns: 1fr; } #company .company-nfe-rt-grid .io-span-2 { grid-column: auto; } }
			#company #nfe_inf_resp_tec_cnpj { width: 100%; max-width: 16rem; }
			#company #nfe_inf_resp_tec_contato { width: 100%; max-width: none; }
			#company #nfe_inf_resp_tec_email { width: 100%; max-width: none; }
			#company #nfe_inf_resp_tec_fone { width: 100%; max-width: 14rem; }
			#company #output_orders_require_full_fulfillment { max-width: min(100%, 44rem); width: 100%; }
			#company .param-select-label { display: block; margin-top: 0.5rem; }
			#company .param-select-label .param-block-title { margin-bottom: 0.35rem; }
		</style>
		<style>
			.company-params-help-body { max-height: 65vh; overflow-y: auto; text-align: left; }
			.company-params-help-body h4 {
				margin: 0.85rem 0 0.25rem 0;
				font-size: 0.78rem;
				font-weight: 700;
				text-transform: uppercase;
				letter-spacing: 0.03em;
				color: #1f2937;
			}
			.company-params-help-body h4:first-child { margin-top: 0; }
			.company-params-help-body p {
				margin: 0;
				font-size: 0.875rem;
				line-height: 1.45;
				color: #374151;
			}
		</style>
		<form id="company" class="form" autocomplete="off">
			<datalist id="strategies">
			</datalist>
			<datalist id="regimes">
			</datalist>
			<datalist id="cities">
			</datalist>
			<datalist id="states">
			</datalist>
			<div class="form-tabs">
				<button type="button" class="form-tab active" data-tab="dados">Dados</button>
				<button type="button" class="form-tab" data-tab="parametros">Parâmetros</button>
				<button type="button" class="form-tab" data-tab="textos">Textos padrões</button>
			</div>
			<div class="form-tab-panels">
			<div id="tab-dados" class="form-tab-panel active">
			<div class="fsb">
				<label title="Identificador da empresa">Empresa
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome curto da empresa">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
				<label title="Nome ou razão social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div>
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="Número do CNPJ">CNPJ<sup>*</sup>
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="Número da Inscrição Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscrição Estadual">Tipo IE<sup>*</sup>
					<input id="ie_type" type="text" list="ie_types" required>
				</label>
				<label class="file"><a id="download" download="logo.png">Logotipo</a>
					<input id="logo" type="file" accept=".png, image/x-png" title="Logotipo para emissão da NFe (~128x128 pixels)">
				</label>
				<!--
				<label title="Inscrição Estadual do Substituto Tributário">IEST
					<input id="iest" type="text">
				</label>
				-->
			</div>
			<div class="fsb">
				<input type="hidden" id="address_id">
				<label title="Logradouro">Logradouro
					<input id="address_street" type="text">
				</label>
				<label title="Número">Número
					<input id="address_number" type="text">
				</label>
				<label title="Complemento">Complemento
					<input id="address_complement" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Bairro">Bairro
					<input id="address_district" type="text">
				</label>
				<label title="Unidade Federativa">UF
					<input id="address_state" type="text" list="states">
				</label>
				<label title="Município">Município
					<input id="address_city_id" type="text" list="cities">
				</label>
				<label title="CEP">CEP
					<input id="address_zipcode" type="text" placeholder="00000-000">
				</label>
			</div>
			<div class="fsb">
				<label title="Estratégia de inventário">Inventário<sup>*</sup>
					<input id="inventory_strategy" type="text" list="strategies" required>
				</label>
				<label title="Código de Regime Tributário">CRT<sup>*</sup>
					<input id="crt" type="text" list="regimes" required>
				</label>
				<label title="Alíquota de PIS">PIS<sup>*</sup>
					<input id="pis" type="text" placeholder="0,00" required>
				</label>
				<label title="Alíquota de COFINS">COFINS<sup>*</sup>
					<input id="cofins" type="text" placeholder="0,00" required>
				</label>
				<label title="Percentual estimado de tributos federais, estaduais e municipais">Tributos
					<input id="estimated_taxes" type="text" placeholder="0,00">
				</label>
				<label title="Série da NFe">Série<sup>*</sup>
					<input id="invoice_series" type="text" placeholder="0" required>
				</label>
				<label title="CPF ou CNPJ das pessoas autorizadas a acessar o XML da NFe">Autorizados
					<input id="authorized_parties" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Modalidade fiscal: normal ou fiel depositário">Modalidade Fiscal
					<select id="fiscal_modality">
						<option value="0">Normal</option>
						<option value="1">Fiel depositário</option>
					</select>
				</label>
				<span id="custody_row">
					<label title="CNPJ do armazenador (obrigatório quando fiel depositário)">CNPJ armazenador
						<input id="custody_warehouse_cnpj" type="text" placeholder="00.000.000/0000-00">
					</label>
				</span>
			</div>
			<div id="custody_emit_nfe_block">
				<p class="custody-emit-title">Emitente na NF-e (armazenador — mesmo CNPJ do certificado A1)</p>
				<p style="font-size:0.8rem;color:#6b7280;margin:0 0 0.5rem 0;">Preencha com os dados cadastrais desse CNPJ na SEFAZ. O depositante continua no cadastro principal acima.</p>
				<div class="fsb">
					<label title="Razão social que consta na SEFAZ para o CNPJ armazenador">Razão social emitente NF-e<sup>*</sup>
						<input id="custody_emit_name" type="text" placeholder="Nome do armazenador">
					</label>
					<label title="IE válida para o CNPJ armazenador (ou ISENTO)">IE emitente NF-e<sup>*</sup>
						<input id="custody_emit_ie" type="text" placeholder="IE ou ISENTO">
					</label>
					<label title="Telefone do emitente (opcional)">Fone emitente
						<input id="custody_emit_phone" type="text" placeholder="+55 (11) 0000-0000">
					</label>
					<label title="CRT do emitente (vazio = mesmo CRT da empresa)">CRT emitente
						<input id="custody_emit_crt" type="text" list="regimes" placeholder="igual empresa">
					</label>
				</div>
				<div class="fsb">
					<input type="hidden" id="custody_emit_address_id">
					<label>Logradouro emitente
						<input id="custody_emit_address_street" type="text">
					</label>
					<label>Número
						<input id="custody_emit_address_number" type="text">
					</label>
					<label>Complemento
						<input id="custody_emit_address_complement" type="text">
					</label>
				</div>
				<div class="fsb">
					<label>Bairro
						<input id="custody_emit_address_district" type="text">
					</label>
					<label>UF
						<input id="custody_emit_address_state" type="text" list="states">
					</label>
					<label>Município
						<input id="custody_emit_address_city_id" type="text" list="cities">
					</label>
					<label>CEP
						<input id="custody_emit_address_zipcode" type="text" placeholder="00000-000">
					</label>
				</div>
			</div>
			</div>
			<div id="tab-parametros" class="form-tab-panel">
			<fieldset class="mtm company-params-fieldset">
				<legend class="company-params-legend">
					<span>Parâmetros operacionais</span>
					<button type="button" class="company-params-help" id="company_params_help" title="Ajuda: significado de cada parâmetro" aria-label="Ajuda sobre parâmetros operacionais">?</button>
				</legend>
				<div class="param-block">
					<h4 class="param-block-title">Pedidos de saída</h4>
					<label class="param-select-label" title="Define se a geração de saída exige atendimento integral de todo o pendente">
						<span class="param-block-title" style="display:block;">Atendimento na geração de saídas</span>
						<select id="output_orders_require_full_fulfillment">
							<option value="0">Parcial — permite saída com atendimento menor que o pendente (padrão)</option>
							<option value="1">Total — só gera saída se todo o pendente for atendido a 100% nesta operação</option>
						</select>
					</label>
				</div>
				<div class="param-block">
					<h4 class="param-block-title">Inventário</h4>
					<div class="param-grid">
						<label class="param-num param-num--row" title="Tolerância de conferência do inventário">
							<span class="param-num-label">Tolerância conferência</span>
							<input id="inv_conference_tolerance" type="text" placeholder="0">
						</label>
						<label class="param-check" title="Permite inventário com lote vencido"><input id="inv_allow_expired" type="checkbox"> <span class="param-check-text">Permite vencido</span></label>
						<label class="param-check" title="Exige lote nas operações de inventário"><input id="inv_require_lot" type="checkbox"> <span class="param-check-text">Exige lote</span></label>
						<label class="param-check" title="Controla inventário por programa"><input id="inv_by_program" type="checkbox"> <span class="param-check-text">Por programa</span></label>
						<label class="param-check" title="Aplica bloqueios por classe no inventário"><input id="inv_class_blocking" type="checkbox"> <span class="param-check-text">Bloqueio por classe</span></label>
					</div>
				</div>
				<div class="param-block">
					<h4 class="param-block-title">Embalagens e picking</h4>
					<div class="param-grid">
						<label class="param-check" title="Ativa hierarquia de embalagens no cliente"><input id="pkg_use_hierarchy" type="checkbox"> <span class="param-check-text">Hierarquia de embalagens</span></label>
						<label class="param-check" title="Permite atendimento unitário (primária)"><input id="pkg_unitarization_enabled" type="checkbox"> <span class="param-check-text">Unitarização</span></label>
						<label class="param-check" title="Motor de picking otimiza escolha de embalagem"><input id="pkg_optimize_picking" type="checkbox"> <span class="param-check-text">Picking otimizado</span></label>
						<label class="param-check" title="Permite quebrar embalagem terciária"><input id="pkg_allow_tertiary_break" type="checkbox"> <span class="param-check-text">Quebra terciária</span></label>
						<label class="param-check" title="Permite quebrar embalagem secundária"><input id="pkg_allow_secondary_break" type="checkbox"> <span class="param-check-text">Quebra secundária</span></label>
						<label class="param-check" title="Valida GTIN por embalagem"><input id="pkg_validate_gtin" type="checkbox"> <span class="param-check-text">Valida GTIN (embalagem)</span></label>
						<label class="param-check" title="Força uso do fluxo legado (rollback)"><input id="pkg_rollback_legacy" type="checkbox"> <span class="param-check-text">Rollback legado</span></label>
					</div>
				</div>
			</fieldset>
			</div>
			<div id="tab-textos" class="form-tab-panel">
				<p class="company-nfe-hint">Modelos de texto para a tag <strong>infCpl</strong> da NF-e (complemento da nota). Definidos <strong>por empresa</strong>; na emissão, os parâmetros entre colchetes são trocados pelos dados do pedido, do cliente/fornecedor e do local de entrega.</p>
				<div class="company-nfe-ph-block">
					<span class="company-nfe-ph-label">Parâmetros — colar no texto de entrada</span>
					<div class="company-nfe-ph-row">
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[FORNECEDOR]">[FORNECEDOR]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[NUMERO NF]">[NUMERO NF]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[LOCAL DE ENTREGA]">[LOCAL DE ENTREGA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[CNPJ EMPRESA (TENNANT)]">[CNPJ EMPRESA (TENNANT)]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[CNPJ FIEL DEPOSITARIO]">[CNPJ FIEL DEPOSITARIO]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[RAZAO SOCIAL EMPRESA]">[RAZAO SOCIAL EMPRESA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[RAZAO SOCIAL EMITENTE]">[RAZAO SOCIAL EMITENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[CLIENTE]">[CLIENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_entrada" data-ph="[CNPJ CLIENTE]">[CNPJ CLIENTE]</button>
					</div>
				</div>
				<label title="Modelo infCpl para notas de entrada (compra / devolução de venda)" class="company-nfe-textarea-label">Texto padrão — NF entrada
					<textarea id="nfe_inf_cpl_entrada" rows="5" placeholder="Ex.: NF ref. [NUMERO NF] do fornecedor [FORNECEDOR]…"></textarea>
				</label>
				<div class="company-nfe-ph-block mtm" style="margin-top:1rem;">
					<span class="company-nfe-ph-label">Parâmetros — colar no texto de saída</span>
					<div class="company-nfe-ph-row">
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CLIENTE]">[CLIENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CNPJ CLIENTE]">[CNPJ CLIENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CPF CLIENTE]">[CPF CLIENTE]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[LOCAL DE ENTREGA]">[LOCAL DE ENTREGA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CNPJ FIEL DEPOSITARIO]">[CNPJ FIEL DEPOSITARIO]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[CNPJ EMPRESA (TENNANT)]">[CNPJ EMPRESA (TENNANT)]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[NUMERO NF]">[NUMERO NF]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[RAZAO SOCIAL EMPRESA]">[RAZAO SOCIAL EMPRESA]</button>
						<button type="button" class="company-inf-cpl-ph" data-target="nfe_inf_cpl_saida" data-ph="[FORNECEDOR]">[FORNECEDOR]</button>
					</div>
				</div>
				<label title="Modelo infCpl para notas de saída (venda / remessa)" class="company-nfe-textarea-label mtm" style="margin-top:0.5rem;">Texto padrão — NF saída
					<textarea id="nfe_inf_cpl_saida" rows="5" placeholder="Ex.: Entrega em [LOCAL DE ENTREGA] para [CLIENTE] CNPJ [CNPJ CLIENTE]…"></textarea>
				</label>
				<hr style="margin:1.25rem 0; border:0; border-top:1px solid #ccc;" />
				<p class="company-nfe-hint" style="margin-bottom:0.5rem;"><strong>Responsável técnico (infRespTec)</strong> — opcional na NF-e de <strong>entrada</strong>; recomendável quando há medicamentos / exigências ANVISA. Preencha <strong>os quatro campos</strong> para o grupo ser incluído no XML de entrada. Se vazio, pode ainda ser usado o fallback do <code>config.ini</code> (<code>[nfe]</code>) quando configurado.</p>
				<div class="company-nfe-rt-grid">
					<label title="CNPJ do responsável técnico (14 dígitos)">CNPJ do RT
						<input id="nfe_inf_resp_tec_cnpj" type="text" placeholder="00.000.000/0001-00" maxlength="18" autocomplete="off">
					</label>
					<label title="Nome do contato (xContato)">Nome do contato (xContato)
						<input id="nfe_inf_resp_tec_contato" type="text" placeholder="Nome completo" maxlength="200" autocomplete="name">
					</label>
					<label title="E-mail do responsável técnico" class="io-span-2">E-mail
						<input id="nfe_inf_resp_tec_email" type="email" placeholder="suporte@exemplo.com.br" maxlength="200" autocomplete="email">
					</label>
					<label title="Telefone (apenas dígitos no XML)">Telefone
						<input id="nfe_inf_resp_tec_fone" type="text" placeholder="01930148080" maxlength="20" autocomplete="tel">
					</label>
				</div>
			</div>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#company',
		init(formset)	// Must not be async as init seq must be preserved
		{
			this.getFieldByName('logo').subscribe(['change'], this.enableDownload.bind(formset), false);	// once = false
			Object.getPrototypeOf(this).init.call(this);
			const root = () => (typeof formset.dialog?.getNode === 'function' ? formset.dialog.getNode() : null) || document.querySelector('#company');
			root()?.addEventListener('click', (ev) => {
				const btn = ev.target?.closest?.('.company-inf-cpl-ph');
				if (!btn) {
					const tab = ev.target?.closest?.('.form-tab');
					if (!tab || !root()) return;
					ev.preventDefault();
					const id = tab.getAttribute('data-tab');
					root().querySelectorAll('.form-tab').forEach((t) => t.classList.remove('active'));
					root().querySelectorAll('.form-tab-panel').forEach((p) => p.classList.remove('active'));
					tab.classList.add('active');
					const panel = root().querySelector(`#tab-${id}`);
					if (panel) panel.classList.add('active');
					return;
				}
				ev.preventDefault();
				const tid = btn.getAttribute('data-target');
				const ph = btn.getAttribute('data-ph') || '';
				const ta = root()?.querySelector(`#${tid}`);
				if (!ta) return;
				const i = ta.selectionStart ?? ta.value.length;
				const j = ta.selectionEnd ?? ta.value.length;
				ta.value = ta.value.slice(0, i) + ph + ta.value.slice(j);
				ta.focus();
				const pos = i + ph.length;
				ta.setSelectionRange(pos, pos);
			});
			const fiscalEl = document.querySelector('#fiscal_modality');
			const custodyRow = document.querySelector('#custody_row');
			const custodyEmitBlock = document.querySelector('#custody_emit_nfe_block');
			const toggleCustody = () => {
				const show = fiscalEl?.value === '1';
				if (custodyRow) custodyRow.style.display = show ? '' : 'none';
				if (custodyEmitBlock) custodyEmitBlock.style.display = show ? 'block' : 'none';
			};
			fiscalEl?.addEventListener('change', toggleCustody);
			if (typeof formset.subscribe === 'function') formset.subscribe(['open'], () => setTimeout(toggleCustody, 0));
			setTimeout(toggleCustody, 0);
			const helpBtn = document.querySelector('#company_params_help');
			helpBtn?.addEventListener('click', (ev) => {
				ev.preventDefault();
				let mb;
				mb = msgbox({
					title: 'Ajuda — Parâmetros operacionais',
					text: COMPANY_PARAMS_HELP_HTML,
					buttons: [{ label: 'Fechar', cls: 'bn_Enter' }],
					callback: () => mb.destroy()
				});
			});
		},
		enableDownload(ev, publisher, value)
		{
			if (value)
			{
				let anchor = document.querySelector('#download');
				anchor.setAttribute('href', `data:image/x-png;base64,${value}`);
				anchor.removeAttribute('disabled');
			}
		},
	},
	
	fields: [
		{ properties: { selector: '#id' }, types: [] },
		{ properties: { selector: '#nick' }, types: [types.name()] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#cnpj' }, types: [types.cnpj()] },
		{ properties: { selector: '#ie' }, types: [types.ie()] },
		{ properties: { selector: '#ie_type' }, types: [types.opt_ie_type(), types.datalist()] },
		//{ properties: { selector: '#iest' }, types: [] },
		{ properties: { selector: '#phone' }, types: [types.phone()] },
		{ properties: { selector: '#address_id' }, types: [] },
		{ properties: { selector: '#address_street' }, types: [types.name()] },
		{ properties: { selector: '#address_number' }, types: [types.name()] },
		{ properties: { selector: '#address_complement' }, types: [types.name()] },
		{ properties: { selector: '#address_district' }, types: [types.name()] },
		{ properties: { selector: '#address_state' }, types: [types.pubsub(), types.opt_uf(), types.datalist()] },
		{ properties: { selector: '#address_city_id' }, types: [types.pubsub(), types.datalist(), types.observer('address_state'), types.obs_load_options('cities', { labels: ['city'], index: 2 })] },
		{ properties: { selector: '#address_zipcode' }, types: [types.cep(), types.obs_cep()] },
		{ properties: { selector: '#inventory_strategy' }, types: [types.opt_inventory_strategy(), types.datalist()] },
		{ properties: { selector: '#crt' }, types: [types.opt_crt(), types.datalist()] },
		{ properties: { selector: '#pis' }, types: [types.number(2)] },
		{ properties: { selector: '#cofins' }, types: [types.number(2)] },
		{ properties: { selector: '#estimated_taxes' }, types: [types.number(2)] },
		{ properties: { selector: '#invoice_series' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#authorized_parties' }, types: [types.array()] },
		{ properties: { selector: '#logo' }, types: [types.pubsub(), types.file()] },
		{ properties: { selector: '#fiscal_modality' }, types: [] },
		{ properties: { selector: '#custody_warehouse_cnpj' }, types: [types.cnpj()] },
		{ properties: { selector: '#custody_emit_name' }, types: [types.name()] },
		{ properties: { selector: '#custody_emit_ie' }, types: [] },
		{ properties: { selector: '#custody_emit_phone' }, types: [types.phone()] },
		{ properties: { selector: '#custody_emit_crt' }, types: [types.opt_crt(), types.datalist()] },
		{ properties: { selector: '#custody_emit_address_id' }, types: [] },
		{ properties: { selector: '#custody_emit_address_street' }, types: [types.name()] },
		{ properties: { selector: '#custody_emit_address_number' }, types: [types.name()] },
		{ properties: { selector: '#custody_emit_address_complement' }, types: [types.name()] },
		{ properties: { selector: '#custody_emit_address_district' }, types: [types.name()] },
		{ properties: { selector: '#custody_emit_address_state' }, types: [types.pubsub(), types.opt_uf(), types.datalist()] },
		{ properties: { selector: '#custody_emit_address_city_id' }, types: [types.pubsub(), types.datalist(), types.observer('custody_emit_address_state'), types.obs_load_options('cities', { labels: ['city'], index: 2 })] },
		{ properties: { selector: '#custody_emit_address_zipcode' }, types: [types.cep(), types.obs_cep()] },
		{ properties: { selector: '#inv_allow_expired' }, types: [types.checkbox()] },
		{ properties: { selector: '#inv_require_lot' }, types: [types.checkbox()] },
		{ properties: { selector: '#inv_by_program' }, types: [types.checkbox()] },
		{ properties: { selector: '#inv_class_blocking' }, types: [types.checkbox()] },
		{ properties: { selector: '#inv_conference_tolerance' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#pkg_use_hierarchy' }, types: [types.checkbox()] },
		{ properties: { selector: '#pkg_unitarization_enabled' }, types: [types.checkbox()] },
		{ properties: { selector: '#pkg_optimize_picking' }, types: [types.checkbox()] },
		{ properties: { selector: '#pkg_allow_tertiary_break' }, types: [types.checkbox()] },
		{ properties: { selector: '#pkg_allow_secondary_break' }, types: [types.checkbox()] },
		{ properties: { selector: '#pkg_validate_gtin' }, types: [types.checkbox()] },
		{ properties: { selector: '#pkg_rollback_legacy' }, types: [types.checkbox()] },
		{ properties: { selector: '#output_orders_require_full_fulfillment' }, types: [] },
		{ properties: { selector: '#nfe_inf_cpl_entrada' }, types: [] },
		{ properties: { selector: '#nfe_inf_cpl_saida' }, types: [] },
		{ properties: { selector: '#nfe_inf_resp_tec_cnpj' }, types: [types.cnpj()] },
		{ properties: { selector: '#nfe_inf_resp_tec_contato' }, types: [types.name()] },
		{ properties: { selector: '#nfe_inf_resp_tec_email' }, types: [] },
		{ properties: { selector: '#nfe_inf_resp_tec_fone' }, types: [types.phone_inf_resp_tec()] },
	]

};

